import React from 'react';

const Contact = () => {
  return (
    <div>
      <h1>Contact Us</h1>
      <p>This is the contact page of your React application!</p>
    </div>
  );
}

export default Contact;